import { IElementCategory } from '@shared/models/element-categories.model';
import { IConditionalNode } from '../../../helpers/conditional-nodes.helpers';
import {
  IFactorySelectProperty,
  ElementPropertyType,
  IFactorySwitchProperty,
} from '../../../models/element-property.model';
import { WoodPropertyName, WoodType } from './wood.model';
import { commonElementCategoryProperties } from '../common-element-category-properties.model';
import { reusedContentProperty } from '../reused-content-property.model';

const woodTypeProperty: IFactorySelectProperty = {
  name: WoodPropertyName.WoodType,
  type: ElementPropertyType.Select,
  count: WoodType.SawnTimber,
  options: Object.values(WoodType),
};

const phenolCoatedProperty: IFactorySwitchProperty = {
  name: WoodPropertyName.PhenolCoated,
  type: ElementPropertyType.Switch,
};

const plywoodConditionalProperty: IConditionalNode<IFactorySwitchProperty> = {
  conditions: {
    [WoodPropertyName.WoodType]: WoodType.Plywood,
  },
  nodes: [phenolCoatedProperty],
};

export const woodProperties: IElementCategory['properties'] = [
  woodTypeProperty,
  plywoodConditionalProperty,
  reusedContentProperty,
  ...commonElementCategoryProperties,
];
